var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagotipo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 0.400011C2.59396 -0.054515 1.78314 -0.127627 1.10557 0.211157C0.428005 0.549941 0 1.24247 0 2.00001V16.4C0 17.1025 0.368597 17.7535 0.971008 18.115L4.1127 20L0.971008 21.885C0.368597 22.2465 0 22.8975 0 23.6V38C0 38.7575 0.428005 39.4501 1.10557 39.7888C1.78314 40.1276 2.59396 40.0545 3.2 39.6L27.2 21.6C27.7036 21.2223 28 20.6295 28 20C28 19.3705 27.7036 18.7777 27.2 18.4L3.2 0.400011ZM4 15.2676V6.00001L22.6667 20L4 34V24.7324L9.02899 21.715C9.6314 21.3535 9.99999 20.7025 9.99999 20C9.99999 19.2975 9.6314 18.6465 9.02899 18.285L4 15.2676ZM23.7171 29.3724C22.8782 28.7225 21.6805 28.5988 20.8207 29.2227C19.8462 29.9298 19.6932 31.3003 20.6121 32.074C23.5162 34.5194 27.311 36 31.4631 36C40.5962 36 47.9999 28.8365 47.9999 20C47.9999 11.1634 40.5962 4 31.4631 4C27.311 4 23.5162 5.48061 20.6121 7.92593C19.6932 8.69965 19.8462 10.0701 20.8207 10.7773C21.6805 11.4012 22.8782 11.2775 23.7171 10.6276C25.8396 8.98333 28.5327 8 31.4631 8C38.3129 8 43.8657 13.3726 43.8657 20C43.8657 26.6274 38.3129 32 31.4631 32C28.5327 32 25.8396 31.0166 23.7171 29.3724Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 48,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagotipo);
export default __webpack_public_path__ + "static/media/Imagotipo.92e4c40ce3b19c702b2c86c48bd916b7.svg";
export { ForwardRef as ReactComponent };